/* eslint-disable no-param-reassign */
const APP = require('APP')
const _ = require('underscore')
const $ = require('jquery')
const Backbone = require('backbone')

const errorHandler = require('Helpers/errorHandler')
const loadScript = require('Helpers/loadScript')
const loadStyle = require('Helpers/loadStyle')
const numbers = require('numbers')
const BaseModel = require('Models/GamePlayBaseModel')
const { gaHelper } = require('../../../app/containers/AnalyticsGoogleTag/gaHelper')

module.exports = BaseModel.extend({
  parseConfig() {
    // eslint-disable-next-line prefer-rest-params
    return BaseModel.prototype.parseConfig.apply(this, arguments).then((config) => {
      if (!config) {
        return null
      }

      const path = this.gameModel.get('html5ReleasePath')
      let translationsData
      let doubleTranslationsData
      let loadData

      if (APP.gameInitData) {
        translationsData = APP.gameInitData.translations
        doubleTranslationsData = APP.gameInitData.doubleTranslations
        loadData = APP.gameInitData.load
      }
      let htmlType = 'js'
      if (config.flashvars.ts === '1') {
        this.gameModel.set('htmlType', 'ts')
        htmlType = 'ts'
        this.view.aspectRatio = this.view.aspectRatioTs
        this.view.onResize()
      }
      let denominateFn
      let denominateFormatFn
      const gamePlayMoneyFormat = config.flashvars.gamePlayMoneyFormat || APP.gamePlayMoneyFormat || 'min-if-denomin-1'

      if (this.playingForFun && config.showCurrencyForFun !== true) {
        // DONT SHOW CURRENCY IN PLAY FOR FUN
        denominateFn = (val, options = gamePlayMoneyFormat) => numbers.creditsToNumberFormat(val, options)
        denominateFormatFn = (val, options = gamePlayMoneyFormat) => numbers.creditsToNumberFormat(val, options)
      } else {
        // SHOW FULL TPL IN DENOMINATION (with *.00)
        denominateFn = (val, options = gamePlayMoneyFormat) => numbers.creditsToMoney(val, options)
        denominateFormatFn = (val, options = gamePlayMoneyFormat) => numbers.creditsToNumberFormat(val, options)
      }

      // eslint-disable-next-line no-param-reassign
      config.flashvars = _.extend(config.flashvars, {
        forFun: this.playingForFun,
        denominateInfoBoxes: true,
        exitMobileAllowed: 1,
        exitDesktopAllowed: 1,
        gameContainer: this.view.$el,
        gameClose: this.view.destroy.bind(this.view),
        resourceRoot: path + (htmlType === 'ts' ? '/' : '/resource/'),
        gamename: this.gameModel.get('name'),
        translationsData,
        doubleTranslationsData,
        loadData,
        canPlay: this.canPlay.bind(this),
        log: this.gameConsoleLog,
        handleError: this.handleError.bind(this),
        handleMessage: this.handleMessage.bind(this),
        registerOnResize: this.view.registerOnResize.bind(this.view),
        registerSID: this.registerSID.bind(this),
        onInitCompleted: this.onInitCompleted.bind(this),
        money: denominateFn,
        gameStartTime: APP.gameStartTime || new Date().getTime(),
        numberFormat: denominateFormatFn,
        millisecondsToHMS: numbers.millisecondsToHMS,
        loadingComplete: () => {
          gaHelper.sendGATimeEvent(`${this.gameModel.get('name')} load html`, true)
        },
      })

      if (!this.playingForFun) {
        // eslint-disable-next-line eqeqeq
        if (config.flashvars.showCCH != 0) {
          const cch = APP.user.limits && APP.user.limits.cch * 1000
          config.flashvars.showCCH = cch || cch === 0 ? 1 : 0 // show cch
          config.flashvars.cch = cch // in milisecundes
        }

        // eslint-disable-next-line eqeqeq
        if (config.flashvars.showCCP != 0) {
          const ccp = APP.user.limits && APP.user.limits.ccp
          config.flashvars.showCCP = ccp || ccp === 0 ? 1 : 0 // show sum loss
          config.flashvars.ccp = ccp // in credits
        }

        // eslint-disable-next-line eqeqeq
        if (config.flashvars.showCH != 0) {
          const ch = APP.user.limits && APP.user.limits.ch * 1000
          config.flashvars.showCH = ch || ch === 0 ? 1 : 0 // show ch
          config.flashvars.ch = ch // in milisecundes
        }

        // eslint-disable-next-line eqeqeq
        if (config.flashvars.showLoginTime != 0) {
          const loginTime = APP.user.limits && APP.user.limits.loginTime * 1000
          config.flashvars.showLoginTime = loginTime || loginTime === 0 ? 1 : 0 // show login Ttime
          config.flashvars.loginTime = loginTime // in milisecundes
        }

        // eslint-disable-next-line eqeqeq
        if (config.flashvars.showHazardInfo != 0) {
          config.flashvars.showHazardInfo = 1 // show hazard addiction info
        }
      }

      // eslint-disable-next-line no-console
      console.info('GAME CONFIG', config)

      return config
    })
  },

  gameConsoleLog() {
    if (window.DEBUG) {
      // eslint-disable-next-line
      console.log('GAME', arguments)
    }
  },

  isReady(config) {
    return new Promise((resolve, reject) => {
      if (window.GAME && window.GAME.ready) {
        resolve(config)
      } else {
        window.GAME = window.GAME || {}
        window.gameReady = () => {
          resolve(config)
        }

        this.loadGameSources(config).catch(reject)
      }
    })
  },

  loadGameSources(config) {
    return new Promise((resolve, reject) => {
      let dataMain
      let errors = 0
      let ok = 0
      const dir = this.gameModel.get('html5ReleasePath')
      const scriptSrc = `${dir}/require.js`
      const stylesSrc = `${dir}/styles/all.css`
      const cb = (e) => {
        if (e.type === 'error') {
          errors++
          if (errors <= 1) {
            reject({ error: errorHandler.getErrorByCode(4100220) })
          }
        } else {
          ok++
          if (ok === 2) {
            resolve(config)
          }
        }
      }

      window.$ = window.$ || $
      window.Backbone = window.Backbone || Backbone
      window._ = window._ || _

      if (APP.IS_ELECTRON) {
        window.preferCanvas = 1
      }

      loadScript(scriptSrc, cb, dataMain)
      if (this.gameModel.get('htmlType') === 'ts') {
        cb({})
      } else {
        loadStyle(stylesSrc, cb)
      }
    })
  },

  destroy() {
    // eslint-disable-next-line prefer-rest-params
    BaseModel.prototype.destroy.apply(this, arguments)

    if (window.GAME.destroy) {
      try {
        window.GAME.destroy()
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err)
      }
    }
    // window.GAME = undefined;
  },
})
